var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import ShowIf from "../../App/ShowIf";
import { Translate } from "../../I18N";
import { Icon } from "../../UI";

import { resetSearch } from "../actions/actions";

class ResetSearch extends Component {
  render() {
    const { connectionsGroups } = this.props;
    return /*#__PURE__*/(
      _jsx(ShowIf, { if: Boolean(connectionsGroups.size) }, void 0, /*#__PURE__*/
      _jsx("button", { type: "button", onClick: this.props.resetSearch, className: "btn btn-default" }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "times" }), /*#__PURE__*/
      _jsx("span", { className: "btn-label" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Clear Filters")
      )
      )
      ));

  }
}






function mapStateToProps({ relationships }) {
  return {
    connectionsGroups: relationships.list.connectionsGroups
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ resetSearch }, dispatch);
}

export { ResetSearch };

export default connect(mapStateToProps, mapDispatchToProps)(ResetSearch);